/* eslint-disable no-underscore-dangle */
import L from 'leaflet';
import { forEach, isEmpty } from 'lodash';
// TODO: Remove this package and use leaflet.vectorgrid when release 1.4.0
import '@bagage/leaflet.vectorgrid';

/**
 * Custom VectorGrid.Protobuf function that returns no style to the not found layers.
 * Now external MapBox Layers should not load unwanted styles.
 */
const CustomProtobuf = L.VectorGrid.Protobuf.extend({
  createTile(coords, done) {
    const storeFeatures = this.options.getFeatureId;

    const tileSize = this.getTileSize();
    const renderer = this.options.rendererFactory(coords, tileSize, this.options);

    const tileBounds = this._tileCoordsToBounds(coords);

    const vectorTilePromise = this._getVectorTilePromise(coords, tileBounds);

    if (storeFeatures) {
      this._vectorTiles[this._tileCoordsToKey(coords)] = renderer;
      renderer._features = {};
    }

    vectorTilePromise.then(
      function renderTile(vectorTile) {
        if (!isEmpty(vectorTile.layers)) {
          forEach(vectorTile.layers, (object, layerName) => {
            this._dataLayerNames[layerName] = true;
            const layer = vectorTile.layers[layerName];

            const pxPerExtent = this.getTileSize().divideBy(layer.extent);

            const layerStyle = this.options.vectorTileLayerStyles[layerName] || [];

            for (let i = 0; i < layer.features.length; i += 1) {
              const feat = layer.features[i];
              let id;

              if (
                this.options.filter instanceof Function &&
                !this.options.filter(feat.properties, coords.z)
              ) {
                return;
              }

              let styleOptions = layerStyle;
              if (storeFeatures) {
                id = this.options.getFeatureId(feat);
                const styleOverride = this._overriddenStyles[id];
                if (styleOverride) {
                  if (styleOverride[layerName]) {
                    styleOptions = styleOverride[layerName];
                  } else {
                    styleOptions = styleOverride;
                  }
                }
              }

              if (styleOptions instanceof Function) {
                styleOptions = styleOptions(feat.properties, coords.z);
              }

              if (!(styleOptions instanceof Array)) {
                styleOptions = [styleOptions];
              }

              if (isEmpty(styleOptions)) {
                return;
              }

              const featureLayer = this._createLayer(feat, pxPerExtent);

              for (let j = 0; j < styleOptions.length; j += 1) {
                const style = L.extend({}, L.Path.prototype.options, styleOptions[j]);
                featureLayer.render(renderer, style);
                renderer._addPath(featureLayer);
              }

              if (this.options.interactive) {
                featureLayer.makeInteractive();
              }

              if (storeFeatures) {
                if (!renderer._features[id]) {
                  renderer._features[id] = [];
                }

                renderer._features[id].push({
                  layerName,
                  feature: featureLayer
                });
              }
            }
          });
        }

        if (this._map != null) {
          renderer.addTo(this._map);
        }

        L.Util.requestAnimFrame(done.bind(coords, null, null));
      }.bind(this)
    );

    return renderer.getContainer();
  }
});

const customProtobuf = (url, options) => {
  return new CustomProtobuf(url, options);
};

export default customProtobuf;
